<script>
import generateColor from 'string-to-color';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    initials: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      profileColor: generateColor(this.name),
    };
  },
};
</script>

<template>
  <div :style="`background-color: ${profileColor}`" class="tw-profile-avatar">
    {{ initials.toUpperCase() }}
  </div>
</template>

<style lang="scss">
  $dimensions: 42px;

  .tw-profile-avatar {
    display: flex;
    align-content: center;
    justify-content: center;
    line-height: $dimensions;
    height: $dimensions;
    width: $dimensions;
    margin-right: 15px;
    border-radius: 50%;
    color: white;
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TwProfileAvatar.vue